import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";


const ExhibitionSelect = ({ list, title, name, value, onChange, focusRef }) => {

    return (
        <FormControl size="small" sx={{ width: "40%", height: "35px", boxSizing: "border-box", display: "flex", justifyContent: "center", marginBottom: "0"}}>
            <InputLabel htmlFor={"exhibition-select"} id="exhibition-select-label">전시관 명칭을 선택해주세요.</InputLabel>
            <Select
                labelId="exhibition-select"
                id="exhibition-select"
                label={title}
                onChange={onChange}
                name={name}
                value={value || ''}
                inputProps={{ ref: focusRef }}
            >
                {list.map((room, index) => (
                    <MenuItem key={room.id} value={room.id} sx={{ maxWidth: "100%", fontSize: "15px", fontFamily: "'Montserrat', 'Noto Sans KR', sans-serif" }}>
                        <span className={"selectSpan ellipsis1"}>
                            {room.roomNo.length > 18 ?
                                room.roomNo.substr(0, 18) + "..."
                                : room.roomNo
                            }
                        </span>
                        <span className={"ellipsis1"} style={{ minWidth: "60%", maxWidth: "80%" }}>
                            {room.name.length > 30 ? <span style={{ maxWidth: "80%" }}>{room.name.substr(0, 30) + "..."}</span> : room.name}
                        </span>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ExhibitionSelect;